const $ = require('jquery')

// =========================================================================
// Module: goUp - scroll to up website
// =========================================================================
const goUp = {
  init () {
    const goUpBtnId = $('#go-up')

    if (goUpBtnId.exists()) {
      goUpBtnId.on('click', function() {
        $('html, body').animate({ scrollTop: 0 }, 'slow')
        return false
      })
    }
  },
}

module.exports = goUp



// WEBPACK FOOTER //
// ./src/modules/goUp.js